module.exports = __webpack_public_path__ + "img/honor_002.66a1614.png";